import React, {useEffect, useState } from "react";
import NavigationBar from "../components/Navigation/NavigationBar"
import Action from '../components/Action';
import Footer from '../components/Footer';
import GoToTop from '../components/GoToTop';
import Loading from "../components/Loading";

function LightLayout({children}) {

  const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
      setTimeout(() => {
        setIsLoading(false);
      }, 200);
    })

  return (
    <>
        {isLoading===true?
            <Loading />:
            <>
            <NavigationBar />
        {/* Any Page Content */}
        {children}
        <Action />
        <Footer />
        {/* <WhatsAppWidget phoneNumber="8847516961" /> */}
        <GoToTop />
        </>
        } 
        </>

  )
}

export default LightLayout;